import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-categoria-gasto-tarjeta',
  templateUrl: './categoria-gasto-tarjeta.component.html',
  styleUrls: ['./categoria-gasto-tarjeta.component.scss']
})
export class CategoriaGastoTarjetaComponent implements OnInit {
  @Input() categoriaGasto : any;
  @Input() isSubcategory : boolean = false;
  @Output() onUpdate : EventEmitter<any> = new EventEmitter();
  @Output() onDelete : EventEmitter<any> = new EventEmitter();
  @Output() onGetSubcategories : EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit() {
  }

  update(){
    this.onUpdate.emit();
  }

  confirmDelete(){
    this.onDelete.emit();
  }

  getSubcategories(){
    this.onGetSubcategories.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/categorias-gastos/categoria-gasto-tarjeta/categoria-gasto-tarjeta.component.ts